import Table from 'src/components/atoms/table/table';

export const ProfileTableHeader = () => {
  return (
    <Table.Row>
      <Table.HeaderCell>Profilo</Table.HeaderCell>
      <Table.HeaderCell>Autorizzazioni</Table.HeaderCell>
      <Table.HeaderCell></Table.HeaderCell>
    </Table.Row>
  );
};
